import { render } from "./BooleanInput.vue?vue&type=template&id=25bbc8a7&scoped=true&ts=true"
import script from "./BooleanInput.vue?vue&type=script&lang=ts"
export * from "./BooleanInput.vue?vue&type=script&lang=ts"

import "./BooleanInput.vue?vue&type=style&index=0&id=25bbc8a7&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bbc8a7"]])

export default __exports__